import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    const isAuthCall = config?.url?.includes("/auth/");
    if (response?.status === 401 && !config._retried && !isAuthCall) {
      config._retried = true;
      const realm = config.url.startsWith("/admin") ? "/admin/auth/refresh" : "/auth/refresh";
      try {
        refreshing = refreshing || api.post(realm).finally(() => (refreshing = null));
        await refreshing;
        return api(config);
      } catch (_) {
        if (!isAuthCall && typeof window !== "undefined" && !window.location.pathname.startsWith("/signin")) {
          const dest = realm.startsWith("/admin") ? "/admin/login" : "/signin";
          window.location.assign(`${dest}?session=ended`);
        }
      }
    }
    return Promise.reject(error);
  }
);

export function errorText(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const CCY_SYMBOL = { CAD: "CA$", USD: "US$", EUR: "€", GBP: "£", AUD: "A$", MXN: "MX$" };

export const money = (cents, currency = "CAD") => {
  if (cents == null) return "—";
  const cur = (currency || "CAD").toUpperCase();
  const noDec = cur === "COP" || cur === "JPY" || cur === "CLP";
  const sym = CCY_SYMBOL[cur];
  if (sym) {
    const num = new Intl.NumberFormat("en-US", { minimumFractionDigits: noDec ? 0 : (cents % 100 ? 2 : 0), maximumFractionDigits: noDec ? 0 : 2 }).format(cents / 100);
    return `${sym}${num}`;
  }
  return new Intl.NumberFormat("en-US", { style: "currency", currency: cur, currencyDisplay: "symbol", minimumFractionDigits: noDec ? 0 : (cents % 100 ? 2 : 0), maximumFractionDigits: noDec ? 0 : 2 }).format(cents / 100);
};

// AI spend is estimated and in USD. Never show "$0" when there were calls.
export const aiCost = (usd, calls = 1) => {
  const n = Number(usd) || 0;
  if (calls > 0 && n < 0.01) return "< US$0.01 est.";
  return `US$${n.toFixed(2)} est.`;
};
